"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const graphic = `
██   ██  ██████  ██   ██
██   ██ ██  ████ ██   ██
███████ ██ ██ ██ ███████
     ██ ████  ██      ██
     ██  ██████       ██
`;
const NotFoundPage = () => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("link", { rel: "stylesheet", type: "text/css", href: "/404.css" }),
        react_1.default.createElement("div", { className: "screen" },
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("pre", { className: "graphic" }, graphic.trim()),
                react_1.default.createElement("span", { className: "title" }, "404 Not Found"),
                react_1.default.createElement("p", null,
                    "A wild 404-PAGE appeared!",
                    react_1.default.createElement("br", null),
                    "This means that the your browser was able to communicate with your given server, but the server could not find what was requested.",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    "* Make sure the url is correct.",
                    react_1.default.createElement("br", null),
                    "* Don't panic.")))));
};
exports.default = NotFoundPage;
